import { InjectionToken } from '@angular/core';

export const API_V1 = new InjectionToken<string>('api path version 1');
export const API_V2 = new InjectionToken<string>('api path version 2');
